module.exports = __webpack_public_path__ + "img/bp-sales-channels.b96e879a.svg";